import Headline from 'components/atoms/headline/Headline'
import Icon from 'components/atoms/icon/Icon';
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle';
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { usePermissions } from 'lib/hooks/shared/usePermissions';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ChangePassword from './change-password/ChangePassword';



const SettingsView = () => {
    const { t } = useTranslation();
    const settings = [
        // {
        //     title: "Users",
        //     description: "Manage individual user accounts and profiles",
        //     icon: IconType.CUSTOMERS_ICON,
        //     color: "#50B8E7",
        //     background: "#50B8E71A",
        //     link: "/settings/users"
        // },
        ...(usePermissions(['roles_management_view'])) ? [{
            title: "Roles & Permissions",
            description: t("Control user access by customizing permissions"),
            icon: IconType.ROLES_ICON,
            color: "#F64E60",
            background: "#F64E601A",
            link: "/settings/roles-permissions"
        }] : [],
        ...(usePermissions(['external_source_api_view'])) ? [{
            title: "External Source",
            description: t("Create Your Api token to connect external sources"),
            icon: IconType.API_TOKEN_ICON,
            color: "#884DFF",
            background: "#884DFF1A",
            link: "/settings/external-source"
        }] : [],
        ...(usePermissions(['data_sharing_teams_view'])) ? [{
            title: "Data Sharing Teams",
            description: t("Organize users into teams to share data for better management"),
            icon: IconType.TEAM_ICON,
            color: "#2CC95B",
            background: "#2CC95B1A",
            link: "/settings/teams"
        }] : [],
        ...(usePermissions(['data_sharing_teams_view'])) ? [{
            title: "Data Sharing Brokers",
            description: t("Organize Brokers into teams to share data for better management"),
            icon: IconType.TEAM_ICON,
            color: "#2CC95B",
            background: "#2CC95B1A",
            link: "/settings/brokers"
        }] : [],
        ...(usePermissions(['data_sharing_teams_view'])) ? [{
            title: "Quality Management",
            description: t("Configure Customer Quality Questions and Additional Quality Settings"),
            icon: IconType.QUALITY_CHECK_ICON,
            color: "#2CC95B",
            background: "#2CC95B1A",
            link: "/settings/quality-management"
        }] : [],

    ];

    const [IsPasswordModalOpen, setIsPasswordModalOpen] = useState(false)

    return (
        <div>
            <Headline title="Settings" />
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-5'>
                {settings.map((setting, index) => (
                    <Link to={setting.link} key={index}>
                        <DashboardBoxLayout >
                            <div className='space-y-4'>
                                <div style={{ backgroundColor: setting.background }} className='h-12 w-12 rounded-xl flex items-center justify-center'>
                                    <Icon iconType={setting.icon} color={setting.color} />
                                </div>
                                <DashboardBoxTitle title={setting.title} />
                                <span className='text-lg text-secondaryTextColor font-inter-regular'>{setting.description}</span>
                            </div>
                        </DashboardBoxLayout>
                    </Link>
                ))}
                <div className='cursor-pointer' onClick={() => setIsPasswordModalOpen(true)}>
                    <DashboardBoxLayout >
                        <div className='space-y-4'>
                            <div style={{ backgroundColor: '#50B8E71A' }} className='h-12 w-12 rounded-xl flex items-center justify-center'>
                                <Icon iconType={IconType.API_TOKEN_ICON} color={'#50B8E7'} />
                            </div>
                            <DashboardBoxTitle title={'Change Password'} />
                            <span className='text-lg text-secondaryTextColor font-inter-regular'>{t('Click here to change your password')}</span>
                        </div>
                    </DashboardBoxLayout>
                </div>
            </div>

            <ChangePassword
                hocisOpen={IsPasswordModalOpen}
                hocToggleModal={() => setIsPasswordModalOpen(false)}
                hocCurrentStep={1}
                hocTitle='Change Password'
                hocClasses={{
                    modalClassName: "w-full max-w-[600px]",
                }}
            />
        </div>
    )
}

export default SettingsView